import React from "react";
import { COLORS, HOTSPOTS } from "../constants";
import { pill, fontSerif } from "./styles";

export default function LandmarksLegend({ activeHotspot }) {
  return (
    <div
      data-testid="zone-legend"
      style={{
        position: "absolute",
        bottom: 22,
        right: 24,
        color: COLORS.ivory,
        fontFamily: fontSerif,
        fontSize: 12,
        letterSpacing: 1,
        ...pill,
        padding: "10px 16px",
      }}
    >
      <div
        style={{
          color: COLORS.gold,
          fontSize: 10,
          letterSpacing: 3,
          marginBottom: 6,
          textTransform: "uppercase",
        }}
      >
        Landmarks
      </div>
      {HOTSPOTS.map((h) => (
        <div
          key={h.id}
          data-testid={`zone-legend-${h.id}`}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginBottom: 2,
            opacity: activeHotspot === h.id ? 1 : 0.85,
          }}
        >
          <span
            style={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              background: COLORS.gold,
              boxShadow: `0 0 8px ${COLORS.gold}`,
            }}
          />
          {h.label}
        </div>
      ))}
    </div>
  );
}
